export default __webpack_public_path__ + "static/飞书20210918-142421-en-c5d994ed94243624ecd6516d1adbba09.png";